import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import {
    seleccionarCampo,
    formatMoneda,
    validaSoloNumero,
    validaMonto,
    onCambioMoneda,
    cmbCedula,
    comboprecios,
    round,
    lpad,
    formatoMonto,
    validarPrecioMontos,
    validarCantidaDos,
    calcularTotales_Dos,
} from "../../util/varios";
import moment from "moment";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoFactura from "../../catalogos/catalogoFactura";
import CatalogoProductoServ from "../../catalogos/catalogoProductoServicios";
import CatalogoNotaEntregaFacturas from "../../catalogos/catalogoNotaEntregaFactura";
import useTableScroll from "../useTableScroll";
import CatalogoSErviDescrip from "../../catalogos/catalogo_servi";

const TablaFactura = () => {
    const op = require("../../../public/modulos/datos");
    const token = sessionStorage.getItem("jwtToken");
    const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
    const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
    const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
    const accbtnfacturas = JSON.parse(sessionStorage.getItem("accbtnfacturasc"));

    const txtNumFactura = useRef();
    const txtStatus = useRef();
    const txtFecha = useRef();
    const txtId = useRef([]);
    const txtIdproducto = useRef([]);
    const txtCantidad = useRef([]);
    const btnIncluir = useRef();
    const btnEliminar = useRef();
    const btnConsultar = useRef();
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const cmbRif = useRef();
    const txtRif = useRef();
    const txtNombreC = useRef();
    const txtSubTotal = useRef();
    const txtExentoTotal = useRef();
    const txtDescuento = useRef();
    const txtTotIva = useRef();
    const txtTotal = useRef();
    const cmbMoneda = useRef();
    const txtFechaVencimiento = useRef();
    const cmbTipoPago = useRef();
    const txtDescripcion = useRef();
    const txtPrecio = useRef([]);
    const tipoTrans = useRef();

    const [body, setBody] = useState(null);
    const [mostrarPago, setMostrarPago] = useState({
        mostrar: false,
        idfactu: null,
    });
    const [operacion, setOperacion] = useState(0);
    const [mostrarFiscal, setMostrarFiscal] = useState(false);
    const [habilitado, setHabilitado] = useState(false);
    const [habilitarCat, setHabilitarCat] = useState(true);
    const [habilitadoBot, setHabilitadoBot] = useState(true);
    const [habilitadoCli, setHabilitadoCli] = useState(false);
    const [selectd, setSelectd] = useState(0);
    const [selectp, setSelectp] = useState(0);
    const [habilitadoProductos, setHabilitadoProductos] = useState(true);
    const [habilitadoMod, setHabilitadoMod] = useState(false);
    const [habilitadoTip, setHabilitadoTip] = useState(false);
    const [indice, setIndice] = useState(null);
    const [visible, setVisible] = useState(0);
    const [mostrar, setMostrar] = useState(false);
    const [habilitarMoneda, setHabilitarMoneda] = useState(false);
    const [records, setRecords] = useState([]);
    const [combomoneda, setComboMoneda] = useState([]);
    const [tituloHeader, setTituloHeader] = useState("Gestionar Facturas.");
    const [catalogoFactura, setCatalogoFactura] = useState(false);
    const [mensaje, setMensaje] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [mensajesino, setMensajesino] = useState({
        mostrar: false,
        titulo: "",
        texto: "",
        icono: "",
    });
    const [moneda, setMoneda] = useState({
        idmoneda: "1",
        descripcion: "BOLIVARES",
        simbolo: "Bs",
        predeterminada: true,
        subpredeterminada: false,
        valormoneda: 1.0,
    });
    const [monedaSub, setMonedaSub] = useState({
        idmoneda: "4",
        descripcion: "DOLAR",
        simbolo: "$",
        predeterminada: false,
        subpredeterminada: true,
        valormoneda: 1.0,
    });
    const [monedaCambio, setMonedaCambio] = useState({
        idmoneda: "4",
        descripcion: "BOLIVARES",
        simbolo: "$",
        predeterminada: false,
        subpredeterminada: true,
        valormoneda: 1.0,
    });
    const [totales, setTotales] = useState({
        subtotal: 0.0,
        descuento: 0.0,
        exento: 0.0,
        sujeto: 0.0,
        iva: 16.0,
        totaliva: 0.0,
        total: 0.0,
    });
    const [valormoney, setValormoney] = useState(0.00);
    const [catalogoNota, setCatalogoNota] = useState(false);
    const [newproduct, setNewproduct] = useState(0);
    const [idsnotas, setIdnotas] = useState([]);
    const [numval, setNumval] = useState("0");
    const [catalogoCliente, setCatalogoCliente] = useState(false);
    const [activate, setActivate] = useState(false);
    const [visibleBtn, setVisibleBtn] = useState("visible");
    const [validafactu, setValidafactu] = useState(1);
    const [factura, setFactura] = useState({
        idfactura: "0",
        numfactura: "000000",
        cedularif: "",
        descripcion: "FACTURA DE PRODUCTOS",
        totalmonto: 0.0,
        totaliva: 0.0,
        totaldescuento: 0.0,
        totalexento: 0.0,
        totalsujeto: 0.0,
        idcliente: "",
        idvendedor: "",
        fecha: moment(fechasistema).format("YYYY-MM-DD"),
        status: 0,
        idalmacen: "",
        idmoneda: "",
        idoperacioninventario: "",
        idnotaentrega: "",
        numnotaentrega: "",
        creditof: false,
        fechavencimientof: moment(fechasistema).format("YYYY-MM-DD"),
        valormoneda: 0.0,
    });
    const [cliente, setCliente] = useState({
        idcliente: "",
        tiporif: "J",
        rif: "",
        nombre: "",
    });
    const [vendedor, setVendedor] = useState({
        idvendedor: "",
        tiporif: "",
        rif: "",
        nombre: "",
        idalmacen: "",
    });

    let nomtabla;

    if (operacion !== 1) {
        nomtabla = [
            { label: "COD-PRODUCTO", textAlign: "center", width: "30px" },
            { label: "PRODUCTO", textAlign: "center", width: "50px" },
            { label: "CANTIDAD", textAlign: "center", width: "20px" },
            { label: "TIPO PRECIO", textAlign: "center", width: "50px" },
            { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
            { label: "UND. ALT.", textAlign: "center", width: "50px" },
            { label: "IVA.", textAlign: "center", width: "50px" },
            { label: "MONTO TOTAL", textAlign: "center", width: "50px" },
        ];
    } else {
        if (selectp !== 1) {
            nomtabla = [
                { label: "COD-PRODUCTO", textAlign: "center", width: "30px" },
                { label: "PRODUCTO", textAlign: "center", width: "50px" },
                { label: "CANTIDAD", textAlign: "center", width: "20px" },
                { label: "TIPO PRECIO", textAlign: "center", width: "50px" },
                { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
                { label: "UND. ALT.", textAlign: "center", width: "50px" },
                { label: "IVA.", textAlign: "center", width: "50px" },
                { label: "MONTO TOTAL", textAlign: "center", width: "50px" },
                {
                    label: <i className="fas fa-trash" />,
                    textAlign: "center",
                    width: "20px",
                },
            ];
        } else {
            nomtabla = [
                { label: "COD-PRODUCTO", textAlign: "center", width: "30px" },
                { label: "PRODUCTO", textAlign: "center", width: "50px" },
                { label: "EXISTENCIA", textAlign: "center", width: "30px" },
                { label: "CANTIDAD", textAlign: "center", width: "20px" },
                { label: "TIPO PRECIO", textAlign: "center", width: "50px" },
                { label: "PRECIO UNI.", textAlign: "center", width: "50px" },
                { label: "UND. ALT.", textAlign: "center", width: "50px" },
                { label: "IVA.", textAlign: "center", width: "50px" },
                { label: "MONTO TOTAL", textAlign: "center", width: "50px" },
                {
                    label: <i className="fas fa-trash" />,
                    textAlign: "center",
                    width: "20px",
                },
            ];
        }
    }

    const headCells = nomtabla;

    const { TblContainer, TblHead } = useTableScroll(headCells);

    const seleccionarMonedas = () => {
        let campos =
            "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
        let nomtab =
            "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
        let orden = "m.idmoneda";

        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    let x = 0;
                    if (response.data.length > 0) {
                        setComboMoneda(response.data);
                        for (let i = 0; i < response.data.length; i++) {
                            if (response.data[i].subpredeterminada) {
                                setMonedaSub(response.data[i]);
                            } else if (response.data[i].predeterminada) {
                                setMoneda(response.data[i]);
                                setMonedaCambio({
                                    idmoneda: response.data[i].idmoneda,
                                    descripcion: response.data[i].descripcion,
                                    simbolo: response.data[i].simbolo,
                                    predeterminada: response.data[i].predeterminada,
                                    subpredeterminada: response.data[i].subpredeterminada,
                                    valormoneda: monedaSub.valormoneda,
                                });
                                x = i;
                            }
                        }
                    }
                    setTimeout(() => (cmbMoneda.current.selectedIndex = x), 200);
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            })
            .finally(() => {
                setActivate(false);
            });
    };

    const seleccionarVendedor = (id) => {
        let campos =
            "v.idagente, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen";
        let nomtab = "agente as v";
        let nomid = "v.idagente";
        let nomid2 = "v.vendedor";
        let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data !== "") {
                        setVendedor({
                            idvendedor: response.data.idagente,
                            tiporif: response.data.tiporifv,
                            rif: response.data.rifv,
                            nombre: response.data.nombrev,
                            idalmacen: response.data.idalmacen,
                        });

                        btnAcepta.current.focus();
                    } else {
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificación",
                            texto: "No existe un vendedor con este codigo",
                            icono: "informacion",
                        });
                    }
                }
                setActivate(false);
            })
            .catch(function (error) {
                setActivate(false);
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
            });
    };

    const seleccionarCliente = (rif, tecla) => {
        let campos =
            "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
        let nomtab = "agente as c";
        let nomid = "c.rif";
        let nomid2 = "c.cliente";
        let id = rif;
        let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data !== "") {
                        txtNombreC.current.value = response.data.nombrec;
                        setCliente({
                            idcliente: response.data.idagente,
                            tiporif: response.data.tiporifc,
                            rif: response.data.rifc,
                            nombre: response.data.nombrec,
                        });
                        if (tecla === 13) {
                            txtFecha.current.focus();
                        }
                    } else {
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificación",
                            texto: "No existe un cliente con este codigo",
                            icono: "informacion",
                        });
                        txtRif.current.value = "";
                        cmbRif.current.selectedIndex = -1;
                        txtNombreC.current.value = "";
                        if (tecla === 13) {
                            txtRif.current.focus();
                        }
                    }
                }
                setActivate(false);
            })
            .catch(function (error) {
                setActivate(false);
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
            });
    };

    const seleccionarProducto = (index, idubi, idprod) => {
        let endpoint = `${op.conexion
            }/api/inventario/seleccionarproductoinv2?idproducto='${idprod.toUpperCase()}'&idalmacen=${idubi}`;
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    let data = [...records];
                    if (response.data !== "") {

                        for (let i = 0; i < records.length; i++) {
                            if (parseInt(records[i].idproducto) === parseInt(response.data.idproducto)) {
                                setActivate(false);
                                setMensaje({
                                    mostrar: true,
                                    titulo: "Notificacion",
                                    texto: "Este Producto ya fue seleccionado.",
                                    icono: "error",
                                });
                                return;
                            }
                        }

                        let uni = [];
                        let precio = 0.0;
                        let montoiva = 0.0;
                        let cantie = response.data.cantidad;
                        let tipouni = 0;
                        let tiene_iva = false;
                        let tipoprecio = parseInt(response.data.tipoprecio);

                        if (parseFloat(response.data.ivaventa) > 0.0) {
                            tiene_iva = true;
                        }

                        if (
                            parseInt(response.data.tipofactor) === 0 ||
                            response.data.tipofactor === null
                        ) {
                            tipouni = 0;
                            uni = [
                                {
                                    idunidad: response.data.idunidadmedida,
                                    descripcion: response.data.descripcionuni,
                                    tipo: "medida",
                                },
                            ];

                            cantie = parseFloat(response.data.cantidad);
                            cantie = Math.trunc(cantie);

                            if (tipoprecio === 1) {
                                precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
                            } else if (tipoprecio === 2) {
                                precio = parseFloat(response.data.precioofe) * monedaSub.valormoneda;
                            } else if (tipoprecio === 3) {
                                precio = parseFloat(response.data.preciomayor) * monedaSub.valormoneda;
                            } else if (tipoprecio === 4) {
                                precio = parseFloat(response.data.preciomini) * monedaSub.valormoneda;
                            }
                        } else {

                            if (
                                parseFloat(response.data.cantidad) < parseFloat(response.data.valorfactor)
                            ) {
                                tipouni = 1;
                                uni = [
                                    {
                                        idunidad: response.data.idunidadalterna,
                                        descripcion: response.data.descripcionunialt,
                                        tipo: "alterna",
                                    },
                                    {
                                        idunidad: response.data.idunidadmedida,
                                        descripcion: response.data.descripcionuni,
                                        tipo: "medida",
                                    },
                                ];

                                cantie = parseFloat(response.data.cantidad);
                                cantie = Math.trunc(cantie);

                                if (tipoprecio === 1) {
                                    if (response.data.servicio === true) {
                                        precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
                                    } else {
                                        precio = parseFloat(response.data.preciomaxialter) * monedaSub.valormoneda;
                                    }
                                } else if (tipoprecio === 2) {
                                    precio = parseFloat(response.data.precioofealter) * monedaSub.valormoneda;
                                } else if (tipoprecio === 3) {
                                    precio = parseFloat(response.data.preciomayoralter) * monedaSub.valormoneda;
                                } else if (tipoprecio === 4) {
                                    precio = parseFloat(response.data.preciominialter) * monedaSub.valormoneda;
                                }
                            } else if (
                                parseFloat(response.data.cantidad) >= parseFloat(response.data.valorfactor)
                            ) {
                                tipouni = 0;
                                uni = [
                                    {
                                        idunidad: response.data.idunidadmedida,
                                        descripcion: response.data.descripcionuni,
                                        tipo: "medida",
                                    },
                                    {
                                        idunidad: response.data.idunidadalterna,
                                        descripcion: response.data.descripcionunialt,
                                        tipo: "alterna",
                                    },
                                ];

                                cantie = parseFloat(
                                    response.data.cantidad / response.data.valorfactor
                                );
                                cantie = Math.trunc(cantie);

                                if (tipoprecio === 1) {
                                    precio = parseFloat(response.data.preciomaxi) * monedaSub.valormoneda;
                                } else if (tipoprecio === 2) {
                                    precio = parseFloat(response.data.precioofe) * monedaSub.valormoneda;
                                } else if (tipoprecio === 3) {
                                    precio = parseFloat(response.data.preciomayor) * monedaSub.valormoneda;
                                } else if (tipoprecio === 4) {
                                    precio = parseFloat(response.data.preciomini) * monedaSub.valormoneda;
                                }
                            }
                        }

                        montoiva = (precio * response.data.ivaventa) / 100;
                        montoiva = round(montoiva, 2);
                        if (index !== null) {
                            data[index] = {
                                idproducto: response.data.idproducto,
                                codigo: response.data.codigo,
                                cantidad: 1.0,
                                cantidadE: response.data.servicio === true ? 1000 : cantie,
                                cantidadEA: parseFloat(response.data.cantidad),
                                nombrecorto: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"
                                    }`,
                                precio: round(precio, 2),
                                precioconiva: round(precio + montoiva, 2),
                                preciobs: 0.0,
                                preciomaxi: response.data.preciomaxi,
                                precioofe: response.data.precioofe,
                                preciomayor: response.data.preciomayor,
                                preciomini: response.data.preciomini,
                                preciomaxialter: response.data.preciomaxialter,
                                precioofealter: response.data.precioofealter,
                                preciomayoralter: response.data.preciomayoralter,
                                preciominialter: response.data.preciominialter,
                                iva: response.data.ivaventa,
                                montoiva: montoiva,
                                totalivas: montoiva,
                                totalsiniva: round(precio, 2),
                                descuento: 0.0,
                                total: round(precio, 2),
                                totaldos: round(precio + montoiva, 2),
                                totalmonto: round(precio + montoiva, 2),
                                unidad: uni,
                                idunidadmedida: response.data.idunidadmedida,
                                idunidadalterna: response.data.idunidadalterna,
                                idalmacen: response.data.idalmacen,
                                idmoneda: response.data.idmoneda,
                                valormoneda: monedaSub.valormoneda,
                                tipounidad: tipouni,
                                tipofactor: response.data.tipofactor,
                                valorfactor: response.data.valorfactor,
                                tipoprecio: response.data.tipoprecio,
                                servicio: response.data.servicio,
                                concepto: 'N/S'.trim().toString(),
                                new: true
                            };
                        } else {
                            data.push({
                                idproducto: response.data.idproducto,
                                codigo: response.data.codigo,
                                cantidad: 1.0,
                                cantidadE: response.data.servicio === true ? 1000 : cantie,
                                cantidadEA: parseFloat(response.data.cantidad),
                                nombrecorto: `${response.data.nombrecorto} ${tiene_iva ? "" : " (E)"
                                    }`,
                                precio: round(precio, 2),
                                precioconiva: round(precio + montoiva, 2),
                                preciomaxi: response.data.preciomaxi,
                                precioofe: response.data.precioofe,
                                preciomayor: response.data.preciomayor,
                                preciomini: response.data.preciomini,
                                preciomaxialter: response.data.preciomaxialter,
                                precioofealter: response.data.precioofealter,
                                preciomayoralter: response.data.preciomayoralter,
                                preciominialter: response.data.preciominialter,
                                preciobs: 0.0,
                                iva: response.data.ivaventa,
                                montoiva: montoiva,
                                descuento: 0.0,
                                totalivas: montoiva,
                                totalsiniva: round(precio, 2),
                                total: round(precio, 2),
                                totaldos: round(precio + montoiva, 2),
                                totalmonto: round(precio + montoiva, 2),
                                unidad: uni,
                                idunidadmedida: response.data.idunidadmedida,
                                idunidadalterna: response.data.idunidadalterna,
                                idalmacen: response.data.idalmacen,
                                idmoneda: response.data.idmoneda,
                                valormoneda: monedaSub.valormoneda,
                                tipounidad: tipouni,
                                tipofactor: response.data.tipofactor,
                                valorfactor: response.data.valorfactor,
                                tipoprecio: response.data.tipoprecio,
                                servicio: response.data.servicio,
                                concepto: 'N/S'.trim().toString(),
                                new: true
                            });
                        }
                        const newProductsCount = data.filter(item => item.new === true).length;
                        setNewproduct(newProductsCount);
                        setRecords(data);
                        let subtotaln = 0.00;
                        let exenton = 0.00;
                        let totalivan = 0.00;
                        let totaln = 0.00;
                        for (let t = 0; t < data.length; t++) {
                            let base = 0.00;
                            if (
                                typeof data[t].totalsiniva !== "undefined" &&
                                data[t].totalsiniva !== null &&
                                !isNaN(parseFloat(data[t].totalsiniva))
                            ) {
                                base = parseFloat(data[t].totalsiniva);
                            } else {
                                base = round(data[t].precio * data[t].cantidad, 2);
                            }
                            if (parseFloat(data[t].iva) > 0) {
                                subtotaln = subtotaln + base;
                                if (
                                    typeof data[t].totalivas !== "undefined" &&
                                    data[t].totalivas !== null &&
                                    !isNaN(parseFloat(data[t].totalivas))
                                ) {
                                    totalivan = totalivan + parseFloat(data[t].totalivas);
                                } else {
                                    totalivan = totalivan + round((base * parseFloat(data[t].iva)) / 100, 2);
                                }
                            } else {
                                exenton = exenton + base;
                            }
                        }
                        totaln = subtotaln + exenton + totalivan;
                        setTotales({
                            subtotal: subtotaln + exenton,
                            descuento: 0.0,
                            exento: exenton,
                            sujeto: subtotaln,
                            iva: 16.0,
                            totaliva: round(totalivan, 2),
                            total: round(totaln, 2),
                        });
                        setIndice(index);
                        if (index !== null) {
                            setTimeout(() => txtCantidad.current[index].focus(), 300);
                        } else {
                            setTimeout(
                                () => txtCantidad.current[data.length - 1].focus(),
                                300
                            );
                        }

                    } else {
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificacion",
                            texto: "no existe un producto con ese codigo en el almacen.",
                            icono: "error",
                        });
                    }
                }
                setActivate(false);
            })
            .catch(function (error) {
                setActivate(false);
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
            });
    };

    const seleccionarFactura = () => {
        const campos =
            "p.*, p.descripcion as descripcionfactura, v.nombre as nombrev,substring(trim(v.rif), 1, 1) as tiporifv, substring(trim(v.rif), 2, 10) as rifv, v.idalmacen, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
        const nomtab =
            "factura as p inner join agente as v on p.idvendedor=v.idagente inner join agente as c on c.idagente=p.idcliente";

        const endpoint = `${op.conexion
            }/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=numfactura&id=${txtNumFactura.current.value.trim()}`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data !== "") {
                        if (
                            response.data.status === 1 &&
                            (operacion === 2)
                        ) {
                            setMensaje({
                                mostrar: true,
                                titulo: "Notificación",
                                texto: "La Facturas ya fue pagada.",
                                icono: "informacion",
                            });
                            setActivate(false);
                            txtNumFactura.current.value = "";
                            txtNumFactura.current.focus();
                            return;
                        }
                        txtFecha.current.value = moment(response.data.fecha).format(
                            "YYYY-MM-DD"
                        );
                        if (operacion !== 1) {
                            txtStatus.current.value = response.data.status;
                        }
                        txtNumFactura.current.setAttribute("disabled", true);
                        cmbRif.current.value = response.data.tiporifc;
                        txtRif.current.value = response.data.rifc;
                        txtNombreC.current.value = response.data.nombrec;

                        for (let i = 0; i < combomoneda.length; i++) {
                            if (response.data.idmoneda === combomoneda[i].idmoneda) {
                                cmbMoneda.current.selectedIndex = i;
                                break;
                            }
                        }

                        if (response.data.creditof) {
                            cmbTipoPago.current.value = "2";
                            txtFechaVencimiento.current.value = moment(
                                response.data.fechavencimientof
                            ).format("YYYY-MM-DD");
                            if (operacion === 2) {
                                setSelectd(1);
                            } else {
                                setSelectd(0);
                            }
                        } else {
                            cmbTipoPago.current.value = "1";
                            txtFechaVencimiento.current.value = "";
                            setSelectd(0);
                        }

                        txtNumFactura.current.value = response.data.numfactura.trim();
                        txtDescripcion.current.value = response.data.descripcionfactura.trim();

                        setHabilitarCat(true);
                        setFactura({
                            idfactura: response.data.idfactura,
                            numfactura: response.data.numfactura,
                            cedularif: response.data.cedularif,
                            descripcion: response.data.descripcionfactura,
                            totalmonto: response.data.totalmonto,
                            totaliva: response.data.totaliva,
                            totaldescuento: response.data.totaldescuento,
                            totalexento: response.data.totalexento,
                            totalsujeto: response.data.totalsujeto,
                            idcliente: response.data.idcliente,
                            idvendedor: response.data.idvendedor,
                            fecha: moment(response.data.fecha).format("YYYY-MM-DD"),
                            status: response.data.status,
                            idalmacen: response.data.idalmacen,
                            idmoneda: response.data.idmoneda,
                            idoperacioninventario: response.data.idoperacioninventario,
                            idnotaentrega: response.data.idnotaentrega,
                            numnotaentrega: response.data.numnotaentrega,
                            creditof: response.data.creditof,
                            fechavencimientof: moment(response.data.fechavencimientof).format(
                                "YYYY-MM-DD"
                            ),
                            valormoneda: response.data.valormoneda,
                        });
                        setCliente({
                            idcliente: response.data.idcliente,
                            tiporif: response.data.tiporifc,
                            rif: response.data.rifc,
                            nombre: response.data.nombrec,
                        });

                        setVendedor({
                            idvendedor: response.data.idvendedor,
                            tiporif: response.data.tiporifv,
                            rif: response.data.rifv,
                            nombre: response.data.nombrev,
                            idalmacen: response.data.idalmacen,
                        });
                        setValormoney(response.data.valormoneda);
                        setTotales({
                            subtotal: (response.data.totalmonto - response.data.totaliva),
                            descuento: response.data.totaldescuento,
                            exento: response.data.totalexento,
                            sujeto: response.data.totalsujeto,
                            iva: 16.0,
                            totaliva: response.data.totaliva,
                            total: response.data.totalmonto,
                        });
                        setHabilitadoTip(false);
                        seleccionarDetalleFactura(response.data.idfactura);
                        if (operacion === 2) {
                            setHabilitado(true);
                            setTimeout(() => txtFecha.current.focus(), 200);
                        } else {
                            setHabilitado(false);
                            setTimeout(() => btnCancela.current.focus(), 200);
                        }
                    } else {
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificación",
                            texto: "no existe una Facturas con ese codigo.",
                            icono: "informacion",
                        });
                        txtNumFactura.current.value = "";
                        txtNumFactura.current.focus();
                    }
                }
            })
            .catch(function (error) {
                setActivate(false);
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
            });
    };

    const seleccionarDetalleFactura = (idfactura) => {
        let nomtab1 = "facturadetalle";
        let nomtab2 = "factura";
        let nomid = "idfactura";
        let endpoint = `${op.conexion}/api/inventario/seleccionarfacturadeta?id=${idfactura}&nomtab1=${nomtab1}&nomtab2=${nomtab2}&nomid=${nomid}`;

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.length > 0) {
                        let prod = [];
                        let uni = [];
                        let montoiva = 0.0;
                        let totalivasc = 0.0;
                        let tipouni = 0;
                        let tiene_iva = false;

                        for (let i = 0; i < response.data.length; i++) {
                            if (parseFloat(response.data[i].iva) > 0.0) {
                                tiene_iva = true;
                            }
                            if (
                                response.data[i].tipounidad === 0 &&
                                parseFloat(response.data[i].valorfactor) <= 0.0
                            ) {
                                tipouni = 0;
                                uni = [
                                    {
                                        idunidad: response.data[i].idunidadmedida,
                                        descripcion: response.data[i].descripcionuni,
                                        tipo: "medida",
                                    },
                                ];
                            } else if (
                                response.data[i].tipounidad === 0 &&
                                parseFloat(response.data[i].valorfactor) > 0.0
                            ) {
                                tipouni = 0;
                                uni = [
                                    {
                                        idunidad: response.data[i].idunidadmedida,
                                        descripcion: response.data[i].descripcionuni,
                                        tipo: "medida",
                                    },
                                    {
                                        idunidad: response.data[i].idunidadalterna,
                                        descripcion: response.data[i].descripcionunialt,
                                        tipo: "alterna",
                                    },
                                ];
                            } else if (response.data[i].tipounidad === 1) {
                                tipouni = 1;
                                uni = [
                                    {
                                        idunidad: response.data[i].idunidadalterna,
                                        descripcion: response.data[i].descripcionunialt,
                                        tipo: "alterna",
                                    },
                                    {
                                        idunidad: response.data[i].idunidadmedida,
                                        descripcion: response.data[i].descripcionuni,
                                        tipo: "medida",
                                    },
                                ];
                            }

                            montoiva = (response.data[i].punitariobs * response.data[i].iva) / 100;
                            montoiva = round(montoiva, 2);

                            totalivasc = round(montoiva * response.data[i].cantidad, 2);

                            prod.push({
                                idproducto: response.data[i].idproducto,
                                codigo: response.data[i].codigo,
                                cantidad: response.data[i].cantidad,
                                nombrecorto: `${response.data[i].nombrecorto} ${tiene_iva ? "" : " (E)"
                                    }`,
                                precio: response.data[i].punitariobs,
                                precioconiva: round(
                                    parseFloat(response.data[i].punitariobs) + montoiva,
                                    2
                                ),
                                preciobs: 0.0,
                                montoiva: montoiva,
                                descuento: 0.0,
                                iva: response.data[i].iva,
                                total: round(
                                    response.data[i].punitariobs * response.data[i].cantidad,
                                    2
                                ),
                                totaldos: round(
                                    response.data[i].punitariobs * response.data[i].cantidad + totalivasc,
                                    2
                                ),
                                totalsiniva: round(
                                    response.data[i].punitariobs * response.data[i].cantidad,
                                    2
                                ),
                                totalivas: totalivasc,
                                totalmonto: round(
                                    response.data[i].punitariobs * response.data[i].cantidad + totalivasc,
                                    2
                                ),
                                unidad: uni,
                                idunidadmedida: response.data[i].idunidadmedida,
                                idunidadalterna: response.data[i].idunidadalterna,
                                idalmacen: response.data[i].idalmacen,
                                valormoneda: response.data[i].valormoneda,
                                tipounidad: tipouni,
                                tipofactor: response.data[i].tipofactor,
                                valorfactor: response.data[i].valorfactor,
                                tipoprecio: response.data[i].tipoprecio,
                                servicio: response.data[i].servicio,
                                concepto: response.data[i].concepto !== null ? response.data[i].concepto.trim() : 'N/S'
                            });

                        }
                        setRecords(prod);
                    }
                }
                setActivate(false);
            })
            .catch(function (error) {
                setActivate(false);
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
            });
    };

    const procesarRegistro = () => {
        setActivate(true);
        console.log(body);
        let endpoint = `${op.conexion}/api/inventario/actualizarfactura2/${operacion}`;
        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    setValidafactu(response.data.idord);
                    if (operacion === 1) {
                        if (response.data.idord < 0) {
                            setMensajesino({
                                mostrar: true,
                                titulo: "Confirmación.",
                                texto: "¿Este Número " + txtNumFactura.current.value.trim() + " de Factura ya fue Utilizado, Desea Actualizarlo?",
                                icono: "confirmacion",
                            });
                        } else {
                            if (factura.creditof !== false) {
                                setMensaje({
                                    mostrar: true,
                                    titulo: "Exito.",
                                    texto:
                                        "Registro " + response.data.idord + " Creado Correctamente",
                                    icono: "exito",
                                });
                            } else {
                                setMensaje({
                                    mostrar: true,
                                    titulo: "Exito.",
                                    texto:
                                        "Registro " + response.data.idord + " Creado Correctamente",
                                    icono: "exito",
                                });
                                var reporte = "Factura";

                                window.open(
                                    op.reportes +
                                    "/ventas?afiliado=" +
                                    afiliado +
                                    "&reporte=" +
                                    reporte +
                                    "&idnota=" +
                                    response.data.idord,
                                    "Planilla",
                                    "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                                );
                            }
                        }
                    } else if (operacion === 2) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto:
                                "Registro " +
                                response.data.idord +
                                " Modificado Correctamente",
                            icono: "exito",
                        });
                    } else if (operacion === 3) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto:
                                "Registro " +
                                response.data.idord +
                                " Anulado Correctamente",
                            icono: "exito",
                        });
                    }
                }
            })
            .catch(function (error) {
                let mensaje = error.response.data.message;
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: mensaje,
                    icono: "error",
                });
            })
            .finally(() => setActivate(false));
    };

    const procesarRegistro2 = () => {
        setActivate(true);
        let endpoint = `${op.conexion}/api/inventario/actualizarfacturanota_dos/${operacion}`;
        axios
            .post(endpoint, body, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    setValidafactu(response.data.idfactur);
                    if (operacion === 1) {
                        if (response.data.idfactur < 0) {
                            setMensajesino({
                                mostrar: true,
                                titulo: "Confirmación.",
                                texto: "¿Este Número " + txtNumFactura.current.value.trim() + " de Factura ya fue Utilizado, Desea Actualizarlo?",
                                icono: "confirmacion",
                            });
                        } else {
                            if (factura.creditof !== false) {
                                setMensaje({
                                    mostrar: true,
                                    titulo: "Exito.",
                                    texto:
                                        "Registro " + response.data.idfactur + " Creado Correctamente",
                                    icono: "exito",
                                });
                            } else {
                                setMensaje({
                                    mostrar: true,
                                    titulo: "Exito.",
                                    texto:
                                        "Registro " + response.data.idfactur + " Creado Correctamente",
                                    icono: "exito",
                                });
                                var reporte = "Factura";

                                window.open(
                                    op.reportes +
                                    "/ventas?afiliado=" +
                                    afiliado +
                                    "&reporte=" +
                                    reporte +
                                    "&idnota=" +
                                    response.data.idfactur,
                                    "Planilla",
                                    "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                                );
                            }
                        }
                    } else if (operacion === 2) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto:
                                "Registro " +
                                response.data.idfactur +
                                " Anulado Correctamente",
                            icono: "exito",
                        });
                    } else if (operacion === 3) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Exito.",
                            texto:
                                "Registro " +
                                response.data.idfactur +
                                " Anulado correctamente",
                            icono: "exito",
                        });
                    }
                }
            })
            .catch(function (error) {
                let mensaje = error.response.data.message;
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: mensaje,
                    icono: "error",
                });
            })
            .finally(() => setActivate(false));
    };

    const validarCliente = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof event.which === "undefined") {
            if (cmbRif.current.value !== "" && event.target.value !== "") {
                let rif = cmbRif.current.value + event.target.value;
                seleccionarCliente(rif, event.which);
            }
        }
    };

    const validarCantidadP = (index, it) => (event) => {
        validaMonto(event);
        if (event.which === 13 || typeof event.which === "undefined") {
            let cantidades = validarCantidaDos({
                index: index,
                event: event,
                productos: records,
            });
            if (event.which === 13) {
                if (index < cantidades.data.length - 1) {
                    setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
                }
            }
            setMensaje(cantidades.msm);
            setRecords(cantidades.data);
            setTotales(cantidades.totales);
        }
    };

    const validarPrecio = (index) => (event) => {
        validaMonto(event);
        if (event.which === 13 || typeof event.which === "undefined") {
            if (selectp !== 1) {
                let montoprecio = validarPrecioMontos({
                    index: index,
                    event: event,
                    productos: records
                });
                if (event.which === 13) {
                    if (index < montoprecio.data.length - 1) {
                        setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
                    }
                }
                setMensaje(montoprecio.msm);
                setRecords(montoprecio.data);
                setTotales(montoprecio.totales);
            } else {
                if (
                    event.target.value === "" ||
                    parseFloat(
                        event.target.value.trim().replace(".", "").replace(",", ".")
                    ) === 0.0
                ) {
                    event.target.value = "1,00";
                }
                event.target.value = formatoMonto(event.target.value);
                let char1 = event.target.value.substring(0, 1);
                let char2 = event.target.value.substring(1, 2);
                if (char1 === "0" && char2 !== ",") {
                    event.target.value = event.target.value.substring(
                        1,
                        event.target.value.length
                    );
                }
                if (event.target.id === "precio") {
                    let data = [...records];
                    let info = [];

                    var preci = parseFloat(
                        event.target.value.replace(/\./g, "").replace(",", ".")
                    );

                    let montoiv = round((preci * data[index].iva) / 100, 2);

                    data[index].precio = preci;
                    data[index].totalsiniva = round(preci * data[index].cantidad, 2);
                    data[index].totalivas = round(montoiv * data[index].cantidad, 2);
                    data[index].totalmonto = round(
                        data[index].totalsiniva + data[index].totalivas,
                        2
                    );
                    data[index].montoiva = data[index].totalivas;
                    data[index].total = data[index].totalsiniva;
                    data[index].totaldos = data[index].totalmonto;

                    setTotales(calcularTotales_Dos(data));
                    setRecords(data);
                }
            }
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };

    const validarIdProducto = (index) => (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof event.which === "undefined") {
            if (event.target.value !== "") {
                seleccionarProducto(index, vendedor.idalmacen, event.target.value);
            }
        }
    };

    const onCatalogoCliente = (values) => {
        setCatalogoCliente(false);
        txtNombreC.current.value = values.nombre;
        cmbRif.current.value = values.rif.substring(0, 1);
        txtRif.current.value = values.rif.substring(1);
        setCliente({
            idcliente: values.idagente,
            tiporif: values.rif.substring(0, 1),
            rif: values.rif.substring(1),
            nombre: values.nombre,
        });
    };

    const onCatalogoFactura = (values) => {
        setCatalogoFactura(false);
        txtNumFactura.current.value = values.numfactura;
        seleccionarFactura();
    };

    const agregarProducto = (producto) => {
        seleccionarProducto(indice, vendedor.idalmacen, producto.codigo);
        setMostrar(false);
    };

    const agregarDescripServi = (value) => {
        setHabilitadoMod(false);
        const nuevosRecords = records.map(record => {
            if (record.servicio === true) {
                return {
                    ...record,
                    concepto: value.trim()
                };
            }
            return record;
        });
        setRecords(nuevosRecords);
    };

    const seleccionarxIndice = (index) => (e) => {
        e.preventDefault();
        if (vendedor.idalmacen !== "" && vendedor.idalmacen !== null) {
            setMostrar(true);
            setIndice(index);
        } else {
            setMensaje({
                mostrar: true,
                titulo: "Notificación.",
                texto: "debe seleccionar un vendedor.",
                icono: "informacion",
            });
        }
    };

    const eliminarProducto = (producto) => (e) => {
        e.preventDefault();

        let data = [...records];
        let elementos = [];

        for (let i = 0; i < data.length; i++) {
            if (producto.idproducto !== data[i].idproducto) {
                elementos.push(data[i]);
            }
        }
        const newProductsCount = elementos.filter(item => item.new === true).length;
        setNewproduct(newProductsCount);
        setRecords(elementos);
        setTotales(calcularTotales_Dos(elementos));

    };

    const abrirModalDescrip = (val) => (e) => {
        if (val !== false) {
            setHabilitadoMod(true);
        } else {
            setHabilitadoMod(false);
        }
    };

    const onChangeMoneda = (e) => {
        let i = e.target.value;
        const cambio = onCambioMoneda({
            moneda: combomoneda[i],
            productos: records,
            monedaPre: moneda,
            monedaSub: monedaSub,
        });
        setMonedaCambio(cambio.monedacambio);
        setRecords(cambio.data);
    };

    const onChangeUnidad = (index) => (e) => {
        e.preventDefault();
        let data = [...records];
        let precio = 0.0;
        let montoiva = 0.0;
        let tipounidad = 0;

        if (parseInt(e.target.value) === parseInt(data[index].idunidadalterna)) {
            tipounidad = 1;
            precio =
                parseFloat(data[index].precio) / parseFloat(data[index].valorfactor);
        } else if (
            parseInt(e.target.value) === parseInt(data[index].idunidadmedida)
        ) {
            tipounidad = 0;
            precio =
                parseFloat(data[index].precio) * parseFloat(data[index].valorfactor);
        }

        montoiva = (precio * parseFloat(data[index].iva)) / 100;

        data[index].tipounidad = tipounidad;
        data[index].precio = precio;
        data[index].unidad = data[index].unidad.reverse();
        data[index].totalsiniva = round(precio * data[index].cantidad, 2);
        data[index].totalivas = round(montoiva * data[index].cantidad, 2);
        data[index].totalmonto = round(
            data[index].totalsiniva + data[index].totalivas,
            2
        );
        data[index].montoiva = data[index].totalivas;
        data[index].total = data[index].totalsiniva;
        data[index].totaldos = data[index].totalmonto;

        setRecords(data);
        setTotales(calcularTotales_Dos(data));
    };

    const onChangeTipoPrecio = (i) => (e) => {
        let data = [...records];
        let tipoprecio = parseInt(e.target.value);
        let tipounidad = data[i].tipounidad;
        let cantidad = data[i].cantidad;
        let precio = 0.0;
        let total = 0.0;

        if (tipounidad === 1) {
            if (tipoprecio === 1) {
                precio = parseFloat(data[i].preciomaxialter) * monedaSub.valormoneda;
            } else if (tipoprecio === 2) {
                precio = parseFloat(data[i].precioofealter) * monedaSub.valormoneda;
            } else if (tipoprecio === 3) {
                precio = parseFloat(data[i].preciomayoralter) * monedaSub.valormoneda;
            } else if (tipoprecio === 4) {
                precio = parseFloat(data[i].preciominialter) * monedaSub.valormoneda;
            }
        } else {
            if (tipoprecio === 1) {
                precio = parseFloat(data[i].preciomaxi) * monedaSub.valormoneda;
            } else if (tipoprecio === 2) {
                precio = parseFloat(data[i].precioofe) * monedaSub.valormoneda;
            } else if (tipoprecio === 3) {
                precio = parseFloat(data[i].preciomayor) * monedaSub.valormoneda;
            } else if (tipoprecio === 4) {
                precio = parseFloat(data[i].preciomini) * monedaSub.valormoneda;
            }
        }

        total = precio * cantidad;

        data[i].tipoprecio = e.target.value;
        data[i].precio = precio;
        data[i].totalsiniva = round(total, 2);
        data[i].totalivas = round(
            (total * parseFloat(data[i].iva)) / 100,
            2
        );
        data[i].totalmonto = round(
            data[i].totalsiniva + data[i].totalivas,
            2
        );
        data[i].montoiva = data[i].totalivas;
        data[i].total = data[i].totalsiniva;
        data[i].totaldos = data[i].totalmonto;

        setRecords(data);
        setTotales(calcularTotales_Dos(data));
    };

    const onChangeValidar = () => {
        let sigue = true;

        if (
            cmbRif.current.value === "" ||
            txtRif.current.value.trim() === "" ||
            txtNombreC.current.value === ""
        ) {
            setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El Cliente no debe estar vacio",
                icono: "informacion",
            });
            sigue = false;
            txtRif.current.focus();
        } else if (txtFecha.current.value.trim() === "") {
            setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "La Fecha no debe estar vacia",
                icono: "informacion",
            });
            sigue = false;
            txtFecha.current.focus();
        } else if (
            cmbTipoPago.current.value === "2" &&
            txtFechaVencimiento.current.value === ""
        ) {
            setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "La Fecha de Vencimiento no debe estar vacia",
                icono: "informacion",
            });
            sigue = false;
            txtFechaVencimiento.current.focus();
        } else if (txtDescripcion.current.value === "") {
            setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "El campo Descripción no debe ir Vacio",
                icono: "informacion",
            });
            sigue = false;
            txtDescripcion.current.focus();
        } else if (records.length === 0) {
            setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "No hay Producto agregados",
                icono: "informacion",
            });
            sigue = false;
            btnCancela.current.focus();
        } else if (records.length > 0 && operacion !== 3) {
            for (let i = 0; i < records.length; i++) {
                if (factura.numnotaentrega === "" || factura.numnotaentrega === null) {
                    if (records[i].cantidadE === 0.0) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificación",
                            texto: "La  cantidad no debe ser mayor a la cantidad existente",
                            icono: "informacion",
                        });
                        sigue = false;
                        btnCancela.current.focus();
                        break;
                    } else if (records[i].cantidadE < records[i].cantidad) {
                        setMensaje({
                            mostrar: true,
                            titulo: "Notificación",
                            texto: "La  cantidad no debe ser mayor a la cantidad existente",
                            icono: "informacion",
                        });
                        sigue = false;
                        btnCancela.current.focus();
                        break;
                    }
                }
            }
        }

        if (sigue) {
            let notaentre = [];
            let notaentredet = [];
            let fact = [];
            let factdet = [];
            var opeinv = [];
            var opeinvdet = [];
            let totaln = 0.00;
            let totalivan = 0.00;
            let totaldescn = 0.00;
            let totalsujn = 0.00;
            let totalexn = 0.00;

            if (newproduct > 0) {
                for (let i = 0; i < records.length; i++) {

                    if (records[i].new !== false) {
                        notaentredet.push({
                            idproducto: records[i].idproducto,
                            cantidad: records[i].cantidad,
                            iva: parseFloat(records[i].iva),
                            punitario: records[i].precio / monedaSub.valormoneda,
                            descuento: "0.00",
                            tipounidad: records[i].tipounidad,
                            idunidadmedida: records[i].idunidadmedida,
                            idunidadalterna: records[i].idunidadalterna,
                            tasa: parseFloat(monedaSub.valormoneda),
                            codproducto: records[i].codigo,
                            costo: records[i].costocalculado / monedaSub.valormoneda,
                            utilidad: records[i].utipreciomaxi / monedaSub.valormoneda,
                            tipopreciodeta: records[i].tipoprecio,
                            status: 1,
                            observacion: records[i].concepto.toUpperCase().trim(),
                            idtipoimpuesto: parseFloat(records[i].iva) <= 16 ? 2 : 1,
                        });
                        if (parseFloat(records[i].iva) > 0) {
                            totalsujn = totalsujn + (parseFloat(records[i].precio) * parseFloat(records[i].cantidad));
                            totalivan = totalivan + (
                                typeof records[i].totalivas !== "undefined" &&
                                records[i].totalivas !== null &&
                                !isNaN(parseFloat(records[i].totalivas))
                                    ? parseFloat(records[i].totalivas)
                                    : (parseFloat(records[i].precio) * parseFloat(records[i].cantidad) * parseFloat(records[i].iva)) / 100
                            );
                        } else {
                            totalexn = totalexn + (parseFloat(records[i].precio) * parseFloat(records[i].cantidad));
                        }
                        totaln = totaln + (parseFloat(records[i].precio) * parseFloat(records[i].cantidad));
                    }

                    if (records[i].servicio !== true && records[i].new !== false) {
                        opeinvdet.push({
                            idproducto: records[i].idproducto,
                            nombre: records[i].nombrecorto,
                            cantidad: records[i].cantidad,
                            precio: records[i].precio / monedaSub.valormoneda,
                            fechavencimiento: factura.creditof
                                ? txtFechaVencimiento.current.value
                                : null,
                            tipomovimiento: "VENTA",
                            fechatipomovimiento: txtFecha.current.value,
                            numfactura: txtNumFactura.current.value.trim(),
                            idalmacen: records[i].idalmacen,
                            tipounidad: records[i].tipounidad,
                            idunidadmedida: records[i].idunidadmedida,
                            idunidadalterna: records[i].idunidadalterna,
                            tipofactor: records[i].tipofactor,
                            valorfactor: records[i].valorfactor,
                            tasa: monedaSub.valormoneda,
                        });
                    }
                }

                opeinv.push({
                    idoperacioninventario: operacion === 1 ? 0 : factura.idoperacioninventario,
                    tipooperacion: "SALIDA",
                    idalmacenorigen: vendedor.idalmacen,
                    idalmacendestino: "",
                    fecha: txtFecha.current.value,
                    idmoneda: monedaCambio.idmoneda,
                    observacion: "VENTA",
                    opeinvdet: opeinvdet,
                    idtipopeinv: "2",
                });

                notaentre.push({
                    indice: 0,
                    idnotaentrega: 0,
                    numnotaentrega: '000000',
                    tipo: "NE",
                    cedularif: cliente.tiporif + cliente.rif,
                    descripcion: "PEDIDO DE PRODUCTO",
                    totalmonto: totaln / monedaSub.valormoneda,
                    totaliva: round(totalivan, 2) / monedaSub.valormoneda,
                    totaldescuento: totaldescn / monedaSub.valormoneda,
                    totalsujeto: totalsujn / monedaSub.valormoneda,
                    totalexento: totalexn / monedaSub.valormoneda,
                    idcliente: cliente.idcliente,
                    idvendedor: vendedor.idvendedor,
                    fecha: txtFecha.current.value,
                    status: 1,
                    idalmacen: vendedor.idalmacen,
                    idmoneda: monedaSub.idmoneda,
                    valormoneda: monedaSub.valormoneda,
                    credito: factura.creditof,
                    fechavencimiento: factura.creditof
                        ? txtFechaVencimiento.current.value
                        : null,
                    idoperacioninventario: factura.idoperacioninventario,
                    mesas: [],
                    notaentredet: notaentredet,
                    opeinv: opeinv,
                });
            } else {
                notaentre = [];
            }

            if (selectp !== 1) {
                fact.push({
                    idfactura: factura.idfactura,
                    numfactura: txtNumFactura.current.value.trim(),
                    descripcion: txtDescripcion.current.value.trim().toUpperCase(),
                    valormoneda: monedaSub.valormoneda,
                    cedularif: cliente.tiporif + cliente.rif,
                    totalmonto: totales.total,
                    totaliva: totales.totaliva,
                    totalexento: totales.exento,
                    totalsujeto: totales.sujeto,
                    totaldescuento: totales.descuento,
                    ...(factura.idnotaentrega !== "" &&
                        factura.idnotaentrega !== null && {
                        idnotaentrega: factura.idnotaentrega,
                    }),
                    idcliente: cliente.idcliente,
                    idvendedor: vendedor.idvendedor,
                    fecha: txtFecha.current.value,
                    status: 1,
                    idalmacen: vendedor.idalmacen,
                    idmoneda: monedaCambio.idmoneda,
                    idoperacioninventario: operacion === 1 ? 0 : factura.idoperacioninventario,
                    creditof: factura.creditof,
                    fechavencimientof: factura.creditof
                        ? txtFechaVencimiento.current.value
                        : null,
                    tipofactu: "VENTA"
                });

                for (let i = 0; i < records.length; i++) {
                    factdet.push({
                        idproducto: records[i].idproducto,
                        cantidad: records[i].cantidad,
                        iva: parseFloat(records[i].iva),
                        punitario: records[i].precio / monedaSub.valormoneda,
                        punitariobs: records[i].precio,
                        descuento: 0.00,
                        tipounidad: records[i].tipounidad,
                        idunidadmedida: records[i].idunidadmedida,
                        idunidadalterna: records[i].idunidadalterna,
                        concepto: records[i].concepto.toUpperCase().trim(),
                        tasa: parseFloat(monedaSub.valormoneda),
                        codproducto: records[i].codigo
                    });
                }
                setBody({
                    factur: fact,
                    facturdet: factdet,
                    idsnotas: idsnotas,
                    notaentrega: notaentre
                });
            } else {
                fact.push({
                    idfactura: factura.idfactura,
                    numfactura: txtNumFactura.current.value.trim(),
                    cedularif: cliente.tiporif + cliente.rif,
                    descripcion: txtDescripcion.current.value.trim().toUpperCase(),
                    valormoneda: monedaSub.valormoneda,
                    totalmonto: totales.total,
                    totaliva: totales.totaliva,
                    totaldescuento: totales.descuento,
                    totalsujeto: totales.sujeto,
                    totalexento: totales.exento,
                    idcliente: cliente.idcliente,
                    idvendedor: vendedor.idvendedor,
                    fecha: txtFecha.current.value,
                    status: 1,
                    idmoneda: monedaCambio.idmoneda,
                    idoperacioninventario: operacion === 1 ? 0 : factura.idoperacioninventario,
                    idalmacen: vendedor.idalmacen,
                    creditof: factura.creditof,
                    fechavencimientof: factura.creditof
                        ? txtFechaVencimiento.current.value
                        : null,
                    tipofactu: "VENTA"
                });

                for (let i = 0; i < records.length; i++) {
                    factdet.push({
                        idproducto: records[i].idproducto,
                        cantidad: records[i].cantidad,
                        iva: parseFloat(records[i].iva),
                        punitario: records[i].precio / monedaSub.valormoneda,
                        punitariobs: records[i].precio,
                        descuento: "0.00",
                        tipounidad: records[i].tipounidad,
                        idunidadmedida: records[i].idunidadmedida,
                        idunidadalterna: records[i].idunidadalterna,
                        concepto: records[i].concepto.toUpperCase().trim(),
                        tasa: monedaSub.valormoneda,
                        codproducto: records[i].codigo,
                        costo: records[i].costocalculado,
                        utilidad: records[i].utipreciomaxi,
                        tipopreciodeta: records[i].tipoprecio,
                        idalmacen: records[i].idalmacen
                    });
                }
                setBody({
                    factur: fact,
                    facturdet: factdet,
                    notaentrega: notaentre
                });
            }

            let msg = "";
            if (operacion === 1) {
                msg = "Esta Seguro de Registrar estos Datos.";
            } else if (operacion === 2) {
                msg = "Esta Seguro de Modificar estos Datos.";
            } else if (operacion === 3) {
                msg = "Esta Seguro de Anular estos Datos.";
            }

            setMensajesino({
                mostrar: true,
                titulo: "Confirmación.",
                texto: msg,
                icono: "confirmacion",
            });
        }
    };

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
        if (validafactu < 0) {
            selectnumfactu();
        } else {
            if (selectp !== 1) {
                procesarRegistro2();
            } else {
                procesarRegistro();
            }
        }
    };

    const blanquear = () => {
        setTituloHeader("Gestionar Facturas.");
        setBody();
        setValormoney(0.00);
        setValidafactu(1);
        setNewproduct(0);
        setActivate(false);
        setMostrarPago({
            mostrar: false,
            idfactu: null,
        });
        txtDescripcion.current.value = "";
        setHabilitado(false);
        setHabilitadoMod(false);
        setHabilitadoTip(false);
        setHabilitarMoneda(false);
        setHabilitadoCli(false);
        setHabilitadoBot(true);
        setHabilitarCat(true);
        setHabilitadoProductos(true);
        setVisible(0);
        setSelectp(0);
        setSelectd(0);
        setVisibleBtn("visible");
        setMoneda({
            idmoneda: "1",
            descripcion: "BOLIVARES",
            simbolo: "Bs",
            predeterminada: false,
            valormoneda: 1.0,
        });
        setMonedaCambio({
            idmoneda: "1",
            descripcion: "BOLIVARES",
            simbolo: "Bs",
            predeterminada: true,
            subpredeterminada: false,
            valormoneda: 1.0,
        });
        setRecords([]);
        for (let i = 0; i < combomoneda.length; i++) {
            if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
                cmbMoneda.current.selectedIndex = i;
            }
        }
        cmbTipoPago.current.value = "1";
        txtNumFactura.current.value = "";
        tipoTrans.current.value = '1';
        txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
        txtFechaVencimiento.current.value =
            moment(fechasistema).format("YYYY-MM-DD");

        cmbRif.current.value = "J";
        txtRif.current.value = "";
        txtNombreC.current.value = "";
        setCliente({
            idcliente: "",
            tiporif: "J",
            rif: "",
            nombre: "",
        });
        setVendedor({
            idvendedor: "",
            tiporif: "",
            rif: "",
            nombre: "",
            idalmacen: "",
        });
        setFactura({
            idfactura: "0",
            numfactura: "000000",
            cedularif: "",
            descripcion: "FACTURAS DE PRODUCTOS",
            totalmonto: 0.0,
            totaliva: 0.0,
            totaldescuento: 0.0,
            totalexento: 0.0,
            totalsujeto: 0.0,
            idcliente: "",
            idvendedor: "",
            fecha: moment(fechasistema).format("YYYY-MM-DD"),
            status: 0,
            idalmacen: "",
            idmoneda: "",
            idoperacioninventario: "",
            idnotaentrega: "",
            numnotaentrega: "",
            creditof: false,
            fechavencimientof: moment(fechasistema).format("YYYY-MM-DD"),
            valormoneda: 0.0,
        });
        setTotales({
            subtotal: 0.0,
            descuento: 0.0,
            exento: 0.0,
            sujeto: 0.0,
            iva: 16.0,
            totaliva: 0.0,
            total: 0.0,
        });
        setOperacion(0);
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    };

    const blanquear_lmpi = () => {
        setBody();
        setTituloHeader("Incluir Facturas.");
        setHabilitadoBot(false);
        setVisibleBtn("hidden");
        setOperacion(1);
        setHabilitadoTip(true);
        setHabilitado(true);
        setHabilitadoCli(true);
        setHabilitadoProductos(false);
        setHabilitarMoneda(true);
        selectnumfactu();
        seleccionarVendedor(idVendedor);
        setHabilitarCat(true);
        txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
        txtDescripcion.current.value = "FACTURA DE PRODUCTOS";
        setMoneda({
            idmoneda: "1",
            descripcion: "BOLIVARES",
            simbolo: "Bs",
            predeterminada: false,
            valormoneda: 1.0,
        });
        setMonedaCambio({
            idmoneda: "1",
            descripcion: "BOLIVARES",
            simbolo: "Bs",
            predeterminada: true,
            subpredeterminada: false,
            valormoneda: 1.0,
        });
        setRecords([]);
        for (let i = 0; i < combomoneda.length; i++) {
            if (combomoneda[i].idmoneda === monedaSub.idmoneda) {
                cmbMoneda.current.selectedIndex = i;
            }
        }
        cmbTipoPago.current.value = "1";
        txtNumFactura.current.value = "";
        cmbRif.current.value = "J";
        txtRif.current.value = "";
        txtNombreC.current.value = "";
        setCliente({
            idcliente: "",
            tiporif: "J",
            rif: "",
            nombre: "",
        });
        setVendedor({
            idvendedor: "",
            tiporif: "",
            rif: "",
            nombre: "",
            idalmacen: "",
        });
        setFactura({
            idfactura: "0",
            numfactura: "000000",
            cedularif: "",
            descripcion: "FACTURAS DE PRODUCTOS",
            totalmonto: 0.0,
            totaliva: 0.0,
            totaldescuento: 0.0,
            totalexento: 0.0,
            totalsujeto: 0.0,
            idcliente: "",
            idvendedor: "",
            fecha: moment(fechasistema).format("YYYY-MM-DD"),
            status: 0,
            idalmacen: "",
            idmoneda: "",
            idoperacioninventario: "",
            idnotaentrega: "",
            numnotaentrega: "",
            creditof: false,
            fechavencimientof: moment(fechasistema).format("YYYY-MM-DD"),
            valormoneda: 0.0,
        });
        setTotales({
            subtotal: 0.0,
            descuento: 0.0,
            exento: 0.0,
            sujeto: 0.0,
            iva: 16.0,
            totaliva: 0.0,
            total: 0.0,
        });
        setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    };

    const handleInputChangeCodigo = (event) => {
        event.preventDefault();
        if (event.which === 13 || typeof event.which === "undefined") {
            if (event.target.value !== "") {
                if (event.target.name === "numfactura") {
                    seleccionarFactura();
                }
            }
        }
    };

    const selectnumfactu = () => {
        let tabla = "factura";
        let id = "idfactura";
        let idtabla = "idfactura";
        let endpoint = `${op.conexion}/api/inventario/consultacodigos?tabla=${tabla}&idtabla=${idtabla}&id=${id}`;

        setActivate(true);

        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.numeroasignado > 0) {
                        let to = parseFloat(response.data.numeroasignado) + 1;
                        let cerrrou = '0000000';
                        let paddedNumber = lpad(to.toString(), cerrrou, 7);
                        txtNumFactura.current.value = paddedNumber;
                        if (txtNumFactura.current.value !== '') {
                            setTimeout(() => txtNumFactura.current.focus(), 200);
                        }
                    } else {
                        txtNumFactura.current.value = "0000001";
                        if (txtNumFactura.current.value !== '') {
                            setTimeout(() => txtNumFactura.current.focus(), 200);
                        }
                    }
                    setValidafactu(1);
                }
            })
            .catch(function (error) {
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
                setActivate(false);
            })
            .finally(() => {
                setActivate(false);
            });
    };

    const onChange = (e) => {
        if (e.target.name === "tipopago") {
            if (e.target.value === "1") {
                setSelectd(0);
                setFactura({
                    ...factura,
                    creditof: false,
                    fechavencimientof: "",
                });
                txtFechaVencimiento.current.value = "";
            } else if (e.target.value === "2") {
                setSelectd(1);
                setFactura({
                    ...factura,
                    creditof: true,
                    fechavencimientof: moment(fechasistema).format("YYYY-MM-DD"),
                });
                txtFechaVencimiento.current.value =
                    moment(fechasistema).format("YYYY-MM-DD");
            }
        } else if (e.target.name === "desde") {
            if (e.target.value === "2") {
                setNumval("1");
            } else if (e.target.value === "1") {
                setNumval("0");
            }
        } else if (e.target.name === "fecha") {
            setFactura({ ...factura, fecha: e.target.value });
        } else if (e.target.name === "fechavencimiento") {
            setFactura({ ...factura, fechavencimientof: e.target.value });
        }

        if (e.target.name === 'tipotrans') {
            if (e.target.value !== '1') {
                blanquear_lmpi();
                tipoTrans.current.value = '2';
                setSelectp(1);
            } else {
                setSelectp(0);
            }
        }
    };

    const imprimirFactura = () => {
        if (accbtnfacturas && accbtnfacturas.toString().substring(4, 5) === "1") {
            let fact = 0;
            if (txtNumFactura.current.value !== "") {
                let idnot = factura.idfactura;

                var reporte = "Factura";

                window.open(
                    op.reportes +
                    "/ventas?afiliado=" +
                    afiliado +
                    "&reporte=" +
                    reporte +
                    "&idnota=" +
                    idnot,
                    "Planilla",
                    "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
                );
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación",
                    texto: "¡ Seleccione la Factura !",
                    icono: "informacion",
                });
                fact = 1;
            }

            if (fact === 1) {
                txtNumFactura.current.focus();
            }
        } else {
            setMensaje({
                mostrar: true,
                titulo: "Notificación.",
                texto: "¡No Posee Permiso para Realizar esta Acción!",
                icono: "error",
            });
        }
    };

    const onBotones = (op) => (e) => {
        e.preventDefault();

        if (op === 1) {
            if (accbtnfacturas && accbtnfacturas.toString().substring(0, 1) === "1") {
                setTituloHeader("Incluir Facturas.");
                setHabilitadoBot(false);
                setVisibleBtn("hidden");
                setOperacion(op);
                setHabilitadoTip(true);
                setHabilitado(true);
                setHabilitadoCli(true);
                setHabilitadoProductos(false);
                setHabilitarMoneda(true);
                selectnumfactu();
                setSelectp(0);
                seleccionarVendedor(idVendedor);
                setHabilitarCat(true);
                tipoTrans.current.value = '1';
                txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
                txtDescripcion.current.value = "FACTURA DE PRODUCTOS";
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }
        } else if (op === 2) {
            if (accbtnfacturas && accbtnfacturas.toString().substring(1, 2) === "1") {
                setTituloHeader("Editar Facturas.");
                setOperacion(op);
                setHabilitarCat(false);
                setHabilitadoBot(false);
                setHabilitadoProductos(false);
                setVisibleBtn("hidden");
                setTimeout(() => txtNumFactura.current.focus(), 200);
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }
        } else if (op === 3) {
            if (accbtnfacturas && accbtnfacturas.toString().substring(3, 4) === "1") {
                setTituloHeader("Eliminar Facturas.");
                setHabilitadoBot(false);
                setVisibleBtn("hidden");
                setOperacion(op);
                setHabilitarCat(false);
                setHabilitadoTip(false);
                setHabilitarMoneda(false);
                setHabilitado(false);
                setHabilitadoCli(false);
                setHabilitadoProductos(true);
                setTimeout(() => txtNumFactura.current.focus(), 200);
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }
        } else if (op === 4) {
            if (accbtnfacturas && accbtnfacturas.toString().substring(2, 3) === "1") {
                setTituloHeader("Consultar Facturas.");
                setHabilitadoBot(false);
                setVisibleBtn("hidden");
                setOperacion(op);
                setHabilitarCat(false);
                setHabilitado(false);
                setHabilitadoTip(false);
                setHabilitarMoneda(true);
                setHabilitadoCli(false);
                setHabilitadoProductos(true);
                setTimeout(() => txtNumFactura.current.focus(), 200);
            } else {
                setMensaje({
                    mostrar: true,
                    titulo: "Notificación.",
                    texto: "¡No Posee Permiso para Realizar esta Acción!",
                    icono: "error",
                });
            }
        } else if (op === 5) {
            onChangeValidar();
        } else if (op === 6) {
            blanquear();
        }
    };

    useEffect(() => {
        seleccionarMonedas();
    }, []);

    const seleccionarNotaEntrega = (datos) => {
        let ids = [];
        let idsnots = [];
        for (let i = 0; i < datos.length; i++) {
            ids.push(parseInt(datos[i].idnota));
            idsnots.push({
                idnota: parseInt(datos[i].idnota)
            });
        }
        setIdnotas(idsnots);
        let endpoint = `${op.conexion}/api/registropago/selectnotaentregafactuid?ids=${ids}`;

        setActivate(true);
        axios
            .get(endpoint, {
                headers: {
                    "x-access-token": `${token}`,
                },
            })
            .then(function (response) {
                if (response.status === 200) {

                    let datapropduct = [];
                    let datos = [];

                    for (let i = 0; i < response.data.length; i++) {

                        datapropduct.push({
                            idproducto: response.data[i].idproducto,
                            codigo: response.data[i].codigoproductoc,
                            nombre: response.data[i].nombreproducto,
                            tipounidad: response.data[i].tipounidadc,
                            idunidadmedida: response.data[i].idunidadmedida,
                            idunidadalterna: response.data[i].idunidadalterna,
                            unidadmedida: response.data[i].unidadmedida,
                            iva: response.data[i].iva,
                            precio: parseFloat(response.data[i].precios),
                            montoiva: parseFloat(response.data[i].montoivac),
                            cantidad: parseFloat(response.data[i].cantidadc),
                            cantidadc: parseFloat(response.data[i].cantidadcaja),
                            cantidadunic: parseFloat(response.data[i].cantiunidxcaja),
                            totalsiniva: parseFloat(response.data[i].totalsiniva),
                            totalmonto: parseFloat(response.data[i].total),
                            valorfactor: parseFloat(response.data[i].valorfactor),
                            servicio: response.data[i].servicio
                        });

                    }

                    const unificarProductos = [];
                    for (const product of datapropduct) {
                        const existingProduct = unificarProductos.find((p) => p.nombre === product.nombre);
                        if (existingProduct) {
                            existingProduct.totalmonto += parseFloat(product.totalmonto);
                            existingProduct.cantidad += parseFloat(product.cantidad);
                            existingProduct.cantidadc += parseFloat(product.cantidadc);
                            existingProduct.cantidadunic += parseFloat(product.cantidadunic);
                            existingProduct.totalsiniva += parseFloat(product.totalsiniva);
                        } else {
                            unificarProductos.push({ ...product });
                        }
                    }

                    let subtotaln = 0.00;
                    let exenton = 0.00;
                    let sujeton = 0.00;
                    let totalivan = 0.00;
                    let totaln = 0.00;
                    let totalv = 0.00;
                    let uni = [];

                    for (let e = 0; e < unificarProductos.length; e++) {

                        let precioproduct = 0.00;
                        let totalcantidad = 0;
                        let montoconiva = 0.00;
                        let montototal = 0.00;
                        let moniva = 0.00;
                        let totaliva = 0.00;
                        let totaliva2 = 0.00;
                        let tipouni = null;


                        if (unificarProductos[e].cantidad > 0 && unificarProductos[e].cantidadc > 0) {
                            precioproduct = round(unificarProductos[e].totalsiniva / (unificarProductos[e].cantidad + unificarProductos[e].cantidadunic), 2);
                            totalcantidad = unificarProductos[e].cantidad + unificarProductos[e].cantidadunic;
                            moniva = round((precioproduct * unificarProductos[e].iva) / 100, 2);
                            totaliva = moniva;
                            totaliva2 = round(moniva * totalcantidad, 2);
                            montoconiva = round((precioproduct + moniva) * totalcantidad, 2);
                            montototal = round(precioproduct * totalcantidad, 2);
                            tipouni = 1;
                        } else if (unificarProductos[e].cantidad > 0 && unificarProductos[e].cantidadc === 0) {
                            precioproduct = round(unificarProductos[e].totalsiniva / unificarProductos[e].cantidad, 2);
                            totalcantidad = unificarProductos[e].cantidad;
                            moniva = round((precioproduct * unificarProductos[e].iva) / 100, 2);
                            totaliva = moniva;
                            totaliva2 = round(moniva * totalcantidad, 2);
                            montoconiva = round((precioproduct + moniva) * totalcantidad, 2);
                            montototal = round(precioproduct * totalcantidad, 2);
                            tipouni = 1;
                        } else {
                            precioproduct = round(unificarProductos[e].totalsiniva / unificarProductos[e].cantidadc, 2);
                            totalcantidad = unificarProductos[e].cantidadc;
                            moniva = round((precioproduct * unificarProductos[e].iva) / 100, 2);
                            totaliva = moniva;
                            totaliva2 = round(moniva * totalcantidad, 2);
                            montoconiva = round((precioproduct + moniva) * totalcantidad, 2);
                            montototal = round(precioproduct * totalcantidad, 2);
                            tipouni = 0;
                        }

                        if (tipouni === 1) {
                            uni = [{
                                idunidad: unificarProductos[e].idunidadalterna,
                                descripcion: "UNIDAD",
                                tipo: "alterna",
                            },
                            {
                                idunidad: unificarProductos[e].idunidadmedida,
                                descripcion: unificarProductos[e].unidadmedida,
                                tipo: "medida",
                            },
                            ];
                        } else {
                            uni = [{
                                idunidad: unificarProductos[e].idunidadmedida,
                                descripcion: unificarProductos[e].unidadmedida,
                                tipo: "medida",
                            },
                            {
                                idunidad: unificarProductos[e].idunidadalterna,
                                descripcion: "UNIDAD",
                                tipo: "alterna",
                            },

                            ];
                        }

                        sujeton = sujeton + montototal;
                        totalivan = totalivan + totaliva2;

                        if (unificarProductos[e].iva > 0) {
                            subtotaln = subtotaln + montototal;
                        } else {
                            exenton = exenton + montototal;
                        }

                        datos.push({
                            idproducto: unificarProductos[e].idproducto,
                            codigo: unificarProductos[e].codigo,
                            cantidad: totalcantidad,
                            nombrecorto: unificarProductos[e].nombre,
                            precio: precioproduct,
                            precioconiva: round(precioproduct + moniva, 2),
                            total: 0.00,
                            totaldos: 0.00,
                            totalivas: totaliva2,
                            totalsiniva: montototal,
                            totalmonto: montoconiva,
                            preciobs: 0.0,
                            iva: unificarProductos[e].iva,
                            montoiva: totaliva,
                            descuento: 0.0,
                            unidad: uni,
                            idunidadmedida: unificarProductos[e].idunidadmedida,
                            idunidadalterna: unificarProductos[e].idunidadalterna,
                            valormoneda: monedaSub.valormoneda,
                            tipounidad: tipouni,
                            valorfactor: unificarProductos[e].valorfactor,
                            concepto: 'N/S'.trim().toString(),
                            new: false,
                            servicio: unificarProductos[e].servicio
                        });

                    }
                    totalv = round(totalivan, 2);
                    totaln = subtotaln + exenton + totalv;
                    setNewproduct(0);
                    setRecords(datos);
                    setTotales({
                        subtotal: round(subtotaln + exenton, 2),
                        descuento: 0.0,
                        exento: round(exenton, 2),
                        sujeto: round(subtotaln, 2),
                        iva: 16.0,
                        totaliva: totalv,
                        total: round(totaln, 2),
                    });
                }
                setActivate(false);
            })
            .catch(function (error) {
                setActivate(false);
                setMensaje({
                    mostrar: true,
                    titulo: "Error",
                    texto: error.response.data.message,
                    icono: "error",
                });
            });
    };

    const onCatalogoNotaEntrega = (values) => {
        setCatalogoNota(false);
        setCliente({
            idcliente: values[0].idcliente,
            tiporif: values[0].rif.substring(0, 1),
            rif: values[0].rif.substring(1, 12),
            nombre: values[0].cliente,
        });
        cmbRif.current.value = values[0].rif.substring(0, 1);
        txtRif.current.value = values[0].rif.substring(1, 12);
        txtNombreC.current.value = values[0].cliente;
        seleccionarNotaEntrega(values);
    };

    return (
        <div style={{ height: "100%", width: "100%" }}>
            <div className="row col-md-12 " style={{ margin: 0 }}>
                <div className="row col-md-12 py-2" style={{ margin: 0 }}>
                    <div className="col-md-11 mx-auto py-2 card shadow">
                        <div className="col-md-12 row border-azul mx-auto rounded py-1">
                            <div className="col-md-12 row mx-auto d-flex justify-content-between mb-1">
                                <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-2 azulGradiant shadow text-light justify-content-between">
                                    <div className="col-md-4">
                                        <h3>{tituloHeader}</h3>
                                    </div>
                                    <div className="col-md-3 d-flex justify-content-end">
                                        <a href="/inicio" className="text-light ">
                                            <i className="fas fa-times mx-2"></i>
                                            <span className="fw-bold">Salir</span>
                                        </a>
                                    </div>
                                </div>

                                <div
                                    className="colfull col-pd-320 mb-3 px-1"
                                    style={{ fontSizeAdjust: "0.6" }}
                                >
                                    <div className="input-group input-group-sm">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            N° FACTURA:
                                        </label>
                                        <input
                                            type="text"
                                            disabled={operacion !== 0 ? false : true}
                                            autoComplete="off"
                                            ref={txtNumFactura}
                                            name="numfactura"
                                            onKeyUp={operacion !== 1 ? handleInputChangeCodigo : null}
                                            onBlur={operacion !== 1 ? handleInputChangeCodigo : null}
                                            onChange={(e) =>
                                                (e.target.value = e.target.value.toUpperCase())
                                            }
                                            className="form-control fs-6"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                        {operacion !== 1 && (
                                            <button
                                                disabled={habilitarCat}
                                                type="button"
                                                onClick={() => setCatalogoFactura(true)}
                                                className="btn btn-success"
                                            >
                                                <i className="fas fa-search"></i>
                                            </button>)}
                                    </div>
                                </div>

                                {operacion !== 1 && (
                                    <div
                                        className="colfull col-pd-230 mb-3 mr-auto px-1"
                                        style={{ fontSizeAdjust: "0.6" }}
                                    >
                                        <div className="input-group input-group-sm">
                                            <label
                                                className="input-group-text"
                                                id="inputGroup-sizing-sm"
                                            >
                                                ESTATUS:
                                            </label>
                                            <select
                                                ref={txtStatus}
                                                style={{
                                                    fontWeight: "bold",
                                                    color:
                                                        factura.status === 0
                                                            ? "#007bff"
                                                            : factura.status === 1
                                                                ? "#28a745"
                                                                : factura.status === 4
                                                                    ? "#dc3545"
                                                                    : "#000000",
                                                }}
                                                disabled
                                                className="form-select form-select-sm text-uppercase px-1"
                                                aria-label=".form-select-sm example"
                                            >
                                                <option value="0">PENDIENTE</option>
                                                <option value="1">PROCESADO</option>
                                                <option value="4">ANULADO</option>
                                            </select>
                                        </div>
                                    </div>
                                )}

                                <div className="colfull col-pd-290 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            TIPO MONEDA:
                                        </label>
                                        <select
                                            className="form-control form-control-sm fw-bold text-center"
                                            disabled
                                            ref={cmbMoneda}
                                            onChange={onChangeMoneda}
                                        >
                                            {combomoneda &&
                                                combomoneda.map((item, index) => (
                                                    <option key={index} value={index}>
                                                        {" "}
                                                        {`${item.descripcion} ${item.simbolo
                                                            } ${formatMoneda(
                                                                item.valormoneda
                                                                    .toString()
                                                                    .replace(",", "")
                                                                    .replace(".", ","),
                                                                ",",
                                                                ".",
                                                                2
                                                            )}`}{" "}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="col-pd-250 ml-auto">
                                    <div className="input-group input-group-sm">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            FECHA:
                                        </label>
                                        <input
                                            type="date"
                                            disabled={!habilitado}
                                            ref={txtFecha}
                                            name="fecha"
                                            onChange={onChange}
                                            className="form-control fs-6 text-uppercase"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div
                                className="col-md-12 row mx-auto mb-1"
                                style={{ fontSizeAdjust: "0.6" }}
                            >

                                <div
                                    className="colfull col-pd-390 mb-3 mr-auto px-1"
                                    style={{ fontSizeAdjust: "0.6" }}
                                >
                                    <div className="input-group input-group-sm">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            TIPO TRANSACCION:
                                        </label>
                                        <select
                                            disabled={!habilitadoTip}
                                            ref={tipoTrans}
                                            onChange={onChange}
                                            className="form-select form-select-sm"
                                            aria-label=".form-select-sm example"
                                            name="tipotrans"
                                            id="tipotrans"
                                        >
                                            <option value="1">POR ORDEN DE ENTREGA</option>
                                            <option value="2">GENERAL</option>
                                        </select>
                                    </div>
                                </div>

                                {selectp !== 1 ? <div
                                    className="colfull col280 mr-auto mb-3 px-1"
                                    style={{ fontSizeAdjust: "0.6" }}
                                >
                                    <div className="input-group input-group-sm">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            NOTA ENTREGA:
                                        </label>
                                        <button
                                            type="button"
                                            disabled={!habilitadoTip}
                                            onClick={() => setCatalogoNota(true)}
                                            className="btn btn-success"
                                        >
                                            <i className="fas fa-search"></i>
                                        </button>
                                    </div>
                                </div> : ''}

                                <div
                                    className="colfull col-pd-240 mb-3 mr-auto px-1"
                                    style={{ fontSizeAdjust: "0.6" }}
                                >
                                    <div className="input-group input-group-sm">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            TIPO PAGO:
                                        </label>
                                        <select
                                            disabled={!habilitadoTip}
                                            ref={cmbTipoPago}
                                            onChange={onChange}
                                            className="form-select form-select-sm"
                                            aria-label=".form-select-sm example"
                                            name="tipopago"
                                            id="tipopago"
                                        >
                                            <option value="1">CONTADO</option>
                                            <option value="2">CREDITO</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="col-pd-390 mr-auto">
                                    <div className="input-group input-group-sm">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            FECHA DE VENCIMIENTO:
                                        </label>
                                        <input
                                            disabled={selectd === 1 ? false : true}
                                            type="date"
                                            name="fechavencimiento"
                                            id="fechavencimiento"
                                            ref={txtFechaVencimiento}
                                            onChange={onChange}
                                            className="form-control text-uppercase fs-6"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div
                                className="colfull1070 col-sm-6 mx-auto mb-1 row m-0"
                                style={{ fontSizeAdjust: "0.6" }}
                            >
                                <div className="col-md-12 mx-auto row mb-1 py-2 border-azul rounded ">
                                    <span className="fw-bold mb-1">Datos del Cliente</span>
                                    <div className="input-group input-group-sm mb-2 col-md-6">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            CEDULA/RIF:{" "}
                                        </label>
                                        <select
                                            ref={cmbRif}
                                            name="cmbrif"
                                            disabled={selectp !== 1 ? true : !habilitadoCli}
                                            className="form-select form-select-sm col-3 text-center"
                                            aria-label=".form-select-sm example"
                                        >
                                            {cmbCedula.map((item, index) => (
                                                <option key={index} value={item.value}>
                                                    {item.value}
                                                </option>
                                            ))}
                                        </select>
                                        <input
                                            ref={txtRif}
                                            autoComplete="off"
                                            disabled={selectp !== 1 ? true : !habilitadoCli}
                                            maxLength={9}
                                            type="text"
                                            className="form-control fs-6"
                                            name="cedula"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                            onKeyUp={validarCliente}
                                            onBlur={validarCliente}
                                        />
                                        <button
                                            disabled={selectp !== 1 ? true : !habilitadoCli}
                                            type="button"
                                            onClick={() => setCatalogoCliente(true)}
                                            className="btn btn-success"
                                            style={{
                                                visibility: visible === 0 ? "visible" : "hidden",
                                            }}
                                        >
                                            <i className="fas fa-search"></i>
                                        </button>
                                    </div>
                                    <div className="input-group input-group-sm mb-2 col-md-12">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            NOMBRE:{" "}
                                        </label>
                                        <input
                                            disabled
                                            autoComplete="off"
                                            type="text"
                                            className="form-control fs-6"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                            ref={txtNombreC}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div
                                className="colfull1070 col-sm-6 mx-auto mb-1 row m-0"
                                style={{ fontSizeAdjust: "0.6" }}
                            >
                                <div className="col-md-12 mx-auto row mb-1 py-2 border-azul rounded ">
                                    <span className="fw-bold mb-1">Datos del Vendedor</span>
                                    <div className="input-group input-group-sm mb-2 col-md-5">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            CEDULA/RIF:{" "}
                                        </label>
                                        <input
                                            disabled
                                            autoComplete="off"
                                            type="text"
                                            className="form-control fs-6"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                            value={vendedor.tiporif + vendedor.rif}
                                        />
                                    </div>
                                    <div className="input-group input-group-sm mb-2 col-md-12">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            NOMBRE:{" "}
                                        </label>
                                        <input
                                            disabled
                                            autoComplete="off"
                                            type="text"
                                            className="form-control fs-6"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                            value={vendedor.nombre}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div
                                className="colfull1070 col-sm-12 mx-auto mb-1 row m-0"
                                style={{ fontSizeAdjust: "0.6" }}
                            >
                                <div className="col-md-12 mx-auto row mb-1 py-2 border-azul rounded ">
                                    <div className="input-group input-group-sm mb-2 col-md-12">
                                        <label
                                            className="input-group-text"
                                            id="inputGroup-sizing-sm"
                                        >
                                            DESCRIPCION:{" "}
                                        </label>
                                        <textarea
                                            disabled={operacion === 1 || operacion === 2 ? false : true}
                                            autoComplete="off"
                                            type="text"
                                            ref={txtDescripcion}
                                            className="form-control fs-6 text-uppercase"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div
                                className="col-md-12 border-azul px-0 rounded"
                                style={{ backgroundColor: "#d5e9ff" }}
                            >
                                <TblContainer
                                    container={{
                                        height: 190,
                                        width: "100%",
                                        overflow: "auto",
                                        padding: "2px",
                                        fontSizeAdjust: "0.6",
                                    }}
                                >
                                    <TblHead />
                                    <TableBody className="overflow-hidden">
                                        {records &&
                                            records.map((item, index) => (
                                                <TableRow key={index} style={{ padding: "0" }}>
                                                    <TableCell className="bg-light d-flex align-items-between px-0">
                                                        <input
                                                            type="text"
                                                            style={{
                                                                borderBottomRightRadius: 0,
                                                                borderTopRightRadius: 0,
                                                            }}
                                                            disabled={item.new !== true ? true : habilitadoProductos}
                                                            ref={(el) => (txtId.current[index] = el)}
                                                            className="form-control form-control-sm bg-light fs-6"
                                                            defaultValue={item.codigo}
                                                            onChange={(e) =>
                                                                (e.target.value = e.target.value.toUpperCase())
                                                            }
                                                            onKeyUp={validarIdProducto(index)}
                                                            onBlur={validarIdProducto(index)}
                                                        />
                                                        {(operacion === 1 ||
                                                            operacion === 2 ||
                                                            factura.numnotaentrega !== "") && (
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        borderBottomLeftRadius: 0,
                                                                        borderTopLeftRadius: 0,
                                                                    }}
                                                                    disabled={item.new !== true ? true : habilitadoProductos}
                                                                    onClick={seleccionarxIndice(index)}
                                                                    className="btn btn-sm btn-primary"
                                                                >
                                                                    <i className="fas ">-</i>
                                                                </button>
                                                            )}
                                                    </TableCell>

                                                    <TableCell
                                                        className="align-middle bg-light text-start p-0 pl-2"
                                                        style={{ width: "300px" }}
                                                    >
                                                        {item.nombrecorto}
                                                        {item.servicio !== true ? '' : <button
                                                            onClick={abrirModalDescrip(item.servicio)}
                                                            disabled={item.new !== true ? true : false}
                                                            className="btn btn-sm btn-info"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </button>}
                                                    </TableCell>

                                                    {operacion !== 1 || operacion === 1 && selectp !== 1 ?
                                                        ""
                                                        :
                                                        <TableCell
                                                            className="align-middle bg-light text-end p-0 pr-2"
                                                            style={{ width: "50px" }}
                                                        >
                                                            {formatMoneda(
                                                                item.cantidadE
                                                                    .toString()
                                                                    .replace(",", "")
                                                                    .replace(".", ","),
                                                                ",",
                                                                ".",
                                                                2
                                                            )}
                                                        </TableCell>
                                                    }

                                                    <TableCell
                                                        className="align-middle bg-light text-center p-0"
                                                        style={{ width: "20px" }}
                                                    >
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm bg-light text-right fs-6 col-pd-90 mx-auto"
                                                            id="cantidad"
                                                            disabled={item.new !== true ? true : habilitadoProductos}
                                                            defaultValue={formatMoneda(
                                                                item.cantidad
                                                                    .toString()
                                                                    .replace(",", "")
                                                                    .replace(".", ","),
                                                                ",",
                                                                ".",
                                                                2
                                                            )}
                                                            ref={(el) => (txtCantidad.current[index] = el)}
                                                            onFocus={seleccionarCampo}
                                                            onKeyUp={validarCantidadP(index, item)}
                                                            onBlur={validarCantidadP(index, item)}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        className="align-middle bg-light p-0"
                                                        style={{ width: 50 }}
                                                    >
                                                        <select
                                                            className="form-control form-control-sm fs-6"
                                                            style={{ width: "100%" }}
                                                            disabled={item.new !== true && item.servicio === true || item.new !== true ? true : habilitadoProductos}
                                                            defaultValue={item.tipoprecio}
                                                            onChange={onChangeTipoPrecio(index)}
                                                        >
                                                            {comboprecios.map((item2, x) => (
                                                                <option key={x} value={item2.id}>
                                                                    {" "}
                                                                    {item2.nombre}{" "}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </TableCell>
                                                    <TableCell
                                                        className="align-middle bg-light text-end p-0 pr-2"
                                                        style={{ width: "50px" }}
                                                    >
                                                        <input
                                                            type="text"
                                                            disabled={item.new !== true ? true : habilitadoProductos}
                                                            onKeyUp={validarPrecio(index)}
                                                            onBlur={validarPrecio(index)}
                                                            className="form-control form-control-sm bg-light text-right fs-6"
                                                            id="precio"
                                                            defaultValue={formatMoneda(
                                                                (item.precio)
                                                                    .toString()
                                                                    .replace(",", "")
                                                                    .replace(".", ","),
                                                                ",",
                                                                ".",
                                                                2
                                                            )}
                                                            ref={(el) => (txtPrecio.current[index] = el)}
                                                        />
                                                    </TableCell>
                                                    <TableCell
                                                        className="align-middle bg-light p-0"
                                                        style={{ width: 60 }}
                                                    >
                                                        <select
                                                            className="form-control form-control-sm fs-6"
                                                            style={{ width: "100%" }}
                                                            disabled={item.new !== true && item.servicio === true || item.new !== true ? true : habilitadoProductos}
                                                            onChange={onChangeUnidad(index)}
                                                        >
                                                            {item.unidad &&
                                                                item.unidad.map((item2, x) => (
                                                                    <option key={x} value={item2.idunidad}>
                                                                        {" "}
                                                                        {item.servicio !== false ? "SERVICIO" : item2.descripcion}{" "}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </TableCell>
                                                    <TableCell
                                                        className="align-middle bg-light text-end p-0 pr-2"
                                                        style={{ width: "50px" }}
                                                    >
                                                        {formatMoneda(
                                                            (item.iva)
                                                                .toString()
                                                                .replace(",", "")
                                                                .replace(".", ","),
                                                            ",",
                                                            ".",
                                                            2
                                                        )}
                                                    </TableCell>
                                                    <TableCell
                                                        className="align-middle bg-light text-end p-0 pr-2"
                                                        style={{ width: "50px" }}
                                                    >
                                                        {formatMoneda(
                                                            (item.totalmonto)
                                                                .toString()
                                                                .replace(",", "")
                                                                .replace(".", ","),
                                                            ",",
                                                            ".",
                                                            2
                                                        )}
                                                    </TableCell>
                                                    {operacion !== 4 && operacion !== 3 && (
                                                        <TableCell
                                                            className="align-middle bg-light text-center p-0"
                                                            style={{ width: "20px" }}
                                                        >
                                                            <button
                                                                disabled={habilitadoProductos}
                                                                style={{
                                                                    visibility:
                                                                        (operacion === 4 || operacion === 3) &&
                                                                        "collapse",
                                                                }}
                                                                onClick={eliminarProducto(item)}
                                                                className="btn btn-sm btn-danger"
                                                            >
                                                                <i className="fa fa-trash"></i>{" "}
                                                            </button>
                                                        </TableCell>
                                                    )}
                                                </TableRow>
                                            ))}
                                        <TableRow style={{ padding: "0" }}>
                                            <TableCell className="bg-light d-flex align-items-between px-0">
                                                <input
                                                    type="text"
                                                    disabled={habilitadoProductos}
                                                    ref={txtIdproducto}
                                                    style={{
                                                        borderBottomRightRadius: 0,
                                                        borderTopRightRadius: 0,
                                                    }}
                                                    className="form-control form-control-sm bg-light text-right"
                                                    onChange={(e) =>
                                                        (e.target.value = e.target.value.toUpperCase())
                                                    }
                                                    onKeyUp={validarIdProducto(null)}
                                                    onBlur={validarIdProducto(null)}
                                                />
                                                <button
                                                    type="button"
                                                    disabled={habilitadoProductos}
                                                    style={{
                                                        borderBottomLeftRadius: 0,
                                                        borderTopLeftRadius: 0,
                                                    }}
                                                    onClick={() => setMostrar(true)}
                                                    className="btn btn-sm btn-primary"
                                                >
                                                    <i className="fas ">-</i>
                                                </button>
                                            </TableCell>

                                            <TableCell
                                                className="align-middle bg-light text-start p-0 pl-2"
                                                style={{ width: "150px" }}
                                            >
                                            </TableCell>
                                            {operacion === 1 && selectp !== 1 ? '' : <TableCell
                                                className="align-middle bg-light text-center p-0"
                                                style={{ width: "20px" }}
                                            >
                                            </TableCell>}
                                            <TableCell
                                                className="align-middle bg-light p-0"
                                                style={{ width: 50 }}
                                            >
                                            </TableCell>
                                            <TableCell
                                                className="align-middle bg-light text-end p-0 pr-2"
                                                style={{ width: "50px" }}
                                            >
                                            </TableCell>
                                            <TableCell
                                                className="align-middle bg-light p-0"
                                                style={{ width: 50 }}
                                            >
                                            </TableCell>
                                            <TableCell
                                                className="align-middle bg-light text-end p-0 pr-2"
                                                style={{ width: "50px" }}
                                            >
                                            </TableCell>
                                            <TableCell
                                                className="align-middle bg-light text-end p-0 pr-2"
                                                style={{ width: "50px" }}
                                            >
                                            </TableCell>
                                            {operacion === 0 || operacion !== 4 && operacion !== 3 && (
                                                <TableCell
                                                    className="align-middle bg-light text-center p-0"
                                                    style={{ width: "20px" }}
                                                >
                                                </TableCell>

                                            )}
                                            {operacion === 0 || operacion !== 4 && operacion !== 3 && (
                                                <TableCell
                                                    className="align-middle bg-light text-center p-0"
                                                    style={{ width: "20px" }}
                                                >
                                                </TableCell>

                                            )}
                                        </TableRow>
                                    </TableBody>
                                </TblContainer>
                            </div>
                            <div className="col-md-12 row m-0 px-0">
                                <div className="col-md-7 py-1 mt-auto">
                                    {visibleBtn === "visible" ? (
                                        <div className="col-pd-600">
                                            <div className="col-md-12 row m-0">
                                                <button
                                                    disabled={!habilitadoBot}
                                                    ref={btnIncluir}
                                                    onClick={onBotones(1)}
                                                    className="btn btn-sm col ml-1 mb-1 btn-primary rounded-pill"
                                                    title="Incluir Factura"
                                                >
                                                    <i className="fas fa-plus"> Incluir </i>{" "}
                                                </button>
                                                <button
                                                    disabled={!habilitadoBot}
                                                    ref={btnConsultar}
                                                    onClick={onBotones(4)}
                                                    className="btn btn-sm col ml-1 mb-1 btn-info rounded-pill"
                                                    title="Consultar Factura"
                                                >
                                                    <i className="fas fa-eye"> Consultar</i>{" "}
                                                </button>
                                                <button
                                                    disabled={!habilitadoBot}
                                                    ref={btnEliminar}
                                                    onClick={onBotones(3)}
                                                    className="btn btn-sm col ml-1 mb-1 btn-danger rounded-pill"
                                                    title="Anular Factura"
                                                >
                                                    <i className="fas fa-window-close"> Anular</i>{" "}
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="col-pd-400 row m-0 ml-auto">
                                            {operacion === 4 ? (
                                                <button
                                                    onClick={imprimirFactura}
                                                    disabled={operacion === 4 ? false : true}
                                                    className="btn btn-sm col ml-1 btn-primary rounded-pill"
                                                    title="Imprimir Factura"
                                                >
                                                    <i className="fa fa-print"> Imprimir</i>
                                                </button>
                                            ) : (
                                                ""
                                            )}

                                            <button
                                                ref={btnAcepta}
                                                disabled={operacion === 4 ? true : habilitadoBot}
                                                onClick={onBotones(5)}
                                                className="btn btn-sm col ml-1 rounded-pill btn-success"
                                            >
                                                <i className="fas fa-check-circle"> Aceptar</i>
                                            </button>
                                            <button
                                                ref={btnCancela}
                                                disabled={habilitadoBot}
                                                onClick={onBotones(6)}
                                                className="btn btn-danger col ml-1 btn-sm rounded-pill"
                                            >
                                                <i className="fas fa-window-close"> Cancelar</i>
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div
                                    className="col-md-5 border-azul rounded shadow"
                                    style={{ backgroundColor: "#dbeeff" }}
                                >
                                    <div
                                        className="input-group input-group-sm col-md-12"
                                        style={{ fontSizeAdjust: "0.6" }}
                                    >
                                        <label
                                            className="input-group-text bg-transparent border-0"
                                            id="inputGroup-sizing-sm"
                                            style={{ fontSize: 14 }}
                                        >
                                            SUBTOTAL {"Bs"}:
                                        </label>

                                        <input
                                            type="text"
                                            disabled
                                            ref={txtSubTotal}
                                            value={formatMoneda(
                                                (totales.subtotal)
                                                    .toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                ",",
                                                ".",
                                                2
                                            )}
                                            className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                    </div>
                                    <div
                                        className="input-group input-group-sm col-md-12"
                                        style={{ fontSizeAdjust: "0.6" }}
                                    >
                                        <label
                                            className="input-group-text bg-transparent border-0"
                                            id="inputGroup-sizing-sm"
                                            style={{ fontSize: 14 }}
                                        >
                                            EXENTO {"Bs"}:
                                        </label>

                                        <input
                                            type="text"
                                            disabled
                                            ref={txtExentoTotal}
                                            value={formatMoneda(
                                                (totales.exento)
                                                    .toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                ",",
                                                ".",
                                                2
                                            )}
                                            className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                    </div>
                                    <div
                                        className="input-group input-group-sm  col-md-12"
                                        style={{ fontSizeAdjust: "0.6" }}
                                    >
                                        <label
                                            className="input-group-text bg-transparent border-0"
                                            id="inputGroup-sizing-sm"
                                            style={{ fontSize: 14 }}
                                        >
                                            DESCUENTO {"Bs"}:
                                        </label>

                                        <input
                                            type="text"
                                            disabled
                                            ref={txtDescuento}
                                            value={formatMoneda(
                                                (totales.descuento)
                                                    .toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                ",",
                                                ".",
                                                2
                                            )}
                                            className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                    </div>
                                    <div
                                        className="input-group input-group-sm  col-md-12"
                                        style={{ fontSizeAdjust: "0.6" }}
                                    >
                                        <label
                                            className="input-group-text bg-transparent border-0"
                                            id="inputGroup-sizing-sm"
                                            style={{ fontSize: 14 }}
                                        >
                                            IVA {"Bs"}:
                                        </label>

                                        <input
                                            type="text"
                                            disabled
                                            ref={txtTotIva}
                                            value={formatMoneda(
                                                (totales.totaliva)
                                                    .toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                ",",
                                                ".",
                                                2
                                            )}
                                            className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                    </div>
                                    <div
                                        className="input-group input-group-sm  col-md-12"
                                        style={{ fontSizeAdjust: "0.6" }}
                                    >
                                        <label
                                            className="input-group-text bg-transparent border-0"
                                            id="inputGroup-sizing-sm"
                                            style={{ fontSize: 14 }}
                                        >
                                            TOTAL {"Bs"}:
                                        </label>

                                        <input
                                            type="text"
                                            disabled
                                            ref={txtTotal}
                                            value={formatMoneda(
                                                (totales.total)
                                                    .toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                ",",
                                                ".",
                                                2
                                            )}
                                            className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                    </div>
                                    <div
                                        className="input-group input-group-sm  col-md-12"
                                        style={{ fontSizeAdjust: "0.6" }}
                                    >
                                        <label
                                            className="input-group-text bg-transparent border-0"
                                            id="inputGroup-sizing-sm"
                                            style={{ fontSize: 14 }}
                                        >
                                            TOTAL {monedaSub.simbolo}:
                                        </label>

                                        <input
                                            type="text"
                                            disabled
                                            ref={txtTotal}
                                            value={operacion !== 1 ? formatMoneda(
                                                (totales.total / valormoney)
                                                    .toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                ",",
                                                ".",
                                                2
                                            ) : formatMoneda(
                                                (totales.total / monedaSub.valormoneda)
                                                    .toString()
                                                    .replace(",", "")
                                                    .replace(".", ","),
                                                ",",
                                                ".",
                                                2
                                            )}
                                            className="form-control bg-transparent text-right fw-bold rounded border-0 fs-5"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CatalogoProductoServ
                show={mostrar}
                onHideCancelar={() => {
                    setMostrar(false);
                }}
                onHideAceptaCatalogo={agregarProducto}
                idalmacen={vendedor.idalmacen}
            />
            <CatalogoSErviDescrip
                show={habilitadoMod}
                onHideCancelar={() => {
                    setHabilitadoMod(false);
                }}
                onHideAceptaCatalogo={agregarDescripServi}
            />
            <CatalogoCliente
                show={catalogoCliente}
                nomid="cliente"
                onHideCancelar={() => setCatalogoCliente(false)}
                onHideAceptaCatalogo={onCatalogoCliente}
            />
            <CatalogoFactura
                show={catalogoFactura}
                tipofactu="factuservi"
                onHideCancelar={() => setCatalogoFactura(false)}
                onHideAceptaCatalogo={onCatalogoFactura}
            />
            <CatalogoNotaEntregaFacturas
                show={catalogoNota}
                nomid="notaentrega"
                tip={"FA"}
                tipo="NE"
                onHideCancelar={() => setCatalogoNota(false)}
                onHideAceptaCatalogo={onCatalogoNotaEntrega}
                condicion="status != 4"
            />
            <Dimmer active={activate} inverted>
                <Loader inverted>cargando...</Loader>
            </Dimmer>
            <Mensaje
                mensaje={mensaje}
                onHide={() =>
                    mensaje.titulo === "Exito."
                        ? blanquear()
                        : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
                }
            />
            <MensajeSiNo
                mensaje={mensajesino}
                onHideNo={() =>
                    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
                }
                onHideSi={handleCloseSi}
            />
        </div>
    );
};
export default TablaFactura;


// WEBPACK FOOTER //
// ./src/components/ventas/tablaFactura.js